export default {
    excess: 'Responsabilidad por daños',
    security: 'Depósito de seguridad',
    fuel_policy: 'Política de combustible',
    like_for_like: 'Igual por igual',
    full_to_full: 'Lleno a lleno',
    mileage: 'Kilometraje: {mileage} millas por alquiler',
    unlimited_mileage: 'Kilometraje ilimitado',
    non_refundable: 'No reembolsable',
    free_cancellation_until: 'Cancelación gratuita hasta {date}',
    cancellation_with_terms: 'Cancelación {0} de acuerdo con ',
    t_c_text: 'Términos y Condiciones',
    two_free_extras: 'Dos extras gratuitos al recoger',
    glass_tyres_covered: 'Cristales y neumáticos cubiertos',
    spec_fuel_petrol: 'gasolina',
    spec_fuel_petrol_diesel: 'gasolina/diésel',
};
